import React, { useEffect, useState } from "react";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import TimeFilter from "components/TimeFilter";
import CheckInStatsDetailCard from "components/CheckInStatsDetailCard";
import Scrollbar from "react-scrollbars-custom";

const styles = {
  detailsContainer: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  loadMoreButton: {
    textAlign: "center",
  },
  timeFilter: {
    height: "35px",
  },
  detailCardContainer: {
    display: "flex",
    flex: 1,
    overflow: "auto",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ opened, team_id, time, setTime }) => {
  const classes = styles;
  const [loading, setLoading] = useState(true);
  const [checkstats, setCheckstats] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!opened) {
      setCheckstats([]);
      setPage(1);
      setLoading(true);

      return;
    }

    (async () => {
      setLoading(true);

      try {
        const response = await TeamService.getCheckInStatsDetails(
          team_id,
          time
        );

        setCheckstats(response.data.data);
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [opened, team_id, page, time]);

  if (!opened) {
    return <Loader loaderStyle={classes.loaderStyle} />;
  }

  const updateTime = (updatedTime) => {
    setTime(updatedTime);
    setPage(1);
  };

  const LoadingContainer = (
    <>
      {loading && (
        <h4 style={{ display: "flex", justifyContent: "center" }}>
          <Loader loaderStyle={classes.loaderStyle} />
        </h4>
      )}
    </>
  );

  return (
    <div style={classes.detailsContainer}>
      <div style={classes.timeFilter}>
        <TimeFilter time={time} setTime={updateTime} />
      </div>
      <div style={classes.detailCardContainer}>
        <Scrollbar>
          <CheckInStatsDetailCard checkstats={checkstats} />
          {LoadingContainer}
        </Scrollbar>
      </div>
    </div>
  );
};
